import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Logo from '../../assets/images/phileas-logo-white.svg';
import LogoCollapsed from '../../assets/images/phileas-logotype-white.png';
import { useHandleResize } from '../../utils/HandleResize';
import { AdminNavMenu } from './AdminNavMenu';
import { UpdateAlert } from '..';

const { Content, Footer, Sider } = Layout;

const StyledLayout = styled.div`
  height: 100vh;
  background: var(--primaryColor);
`;

const StyledSider = styled.div`
  height: 100vh;
  z-index: 10;
  overflow-x: hidden;
  position: fixed;
  left: 0;
  background-color: var(--clientColor);
`;

const StyledContent = styled.div`
  margin: 0 0 0 255px;
  padding: 24px 0 0;
  background: var(--primaryColor);
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  @media (max-width: 992px) {
    margin-left: 80px;
  }

  @media (max-width: 576px) {
    margin-left: 0;
  }
`;

const StyledFooter = styled.footer`
  padding: 8px 25px;
  text-align: center;
  background-color: var(--bodyBackground);
  color: var(--textColor);
`;

export const AdminLayout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(window.innerWidth < 992);
  const { width, height } = useHandleResize();
  const [collapseWidth, setCollapseWidth] = useState(
    window.innerWidth < 576 ? 0 : 80
  );

  const onCollapse = (newCollapsed) => {
    setCollapsed(newCollapsed);
  };

  useEffect(() => {
    if (width < 576) {
      setCollapseWidth(0);
    } else {
      setCollapseWidth(80);
    }
  }, [width, height]);

  useEffect(() => {
    document
      .getElementById('mainContent')
      .scrollTo({ behavior: 'smooth', top: 0 });
  }, [location]);

  return (
    <StyledLayout as={Layout}>
      <UpdateAlert />
      <StyledSider
        as={Sider}
        width={255}
        breakpoint="lg"
        trigger={null}
        collapsible
        collapsedWidth={collapseWidth}
        collapsed={collapsed}
        onCollapse={onCollapse}
        className="aside-menu"
      >
        <div className="logo-phileas">
          <Link to="/">
            <img alt="Logo" src={collapsed ? LogoCollapsed : Logo} />
          </Link>
        </div>
        <AdminNavMenu setCollapsed={setCollapsed} />
      </StyledSider>
      <Layout className="layout-bg">
        <StyledContent as={Content} id="mainContent" className="main-content">
          <Outlet />
          <StyledFooter as={Footer}>
            {`${t('global.title')} ©${moment().year()} powered by `}
            <a href="https://strateg.in">Strateg.in</a>
          </StyledFooter>
        </StyledContent>
      </Layout>
    </StyledLayout>
  );
};
